const config = {
    basename: '',
    defaultPath: '/',
    apiBaseURL: process.env.REACT_APP_API_BASE_URL,
    BUCKET_URL:process.env.BUCKET_URL
};

export default config;
